import { jsxs, jsx } from 'react/jsx-runtime';

const FLEX_GRADIENT_SVG_ID = {
  flame: "flex-gradient-svg-flame",
  magic: "flex-gradient-svg-magic",
  mango: "flex-gradient-svg-mango",
  tropical: "flex-gradient-svg-tropical"
};
function FlexLinearGradient({ id }) {
  return /* @__PURE__ */ jsxs("defs", { children: [
    /* @__PURE__ */ jsxs("linearGradient", { id: getId("flame", id), gradientTransform: "rotate(4.77)", children: [
      /* @__PURE__ */ jsx("stop", { offset: "0%", stopColor: "#f96919" }),
      /* @__PURE__ */ jsx("stop", { offset: "100%", stopColor: "#FB60BD" })
    ] }),
    /* @__PURE__ */ jsxs("linearGradient", { id: getId("magic", id), gradientTransform: "rotate(4.77)", children: [
      /* @__PURE__ */ jsx("stop", { offset: "0%", stopColor: "#a348ff" }),
      /* @__PURE__ */ jsx("stop", { offset: "100%", stopColor: "#6066FF" })
    ] }),
    /* @__PURE__ */ jsxs(
      "linearGradient",
      {
        id: getId("tropical", id),
        gradientTransform: "rotate(4.77)",
        children: [
          /* @__PURE__ */ jsx("stop", { offset: "0%", stopColor: "#04CC00" }),
          /* @__PURE__ */ jsx("stop", { offset: "100%", stopColor: "#12C2CD" })
        ]
      }
    ),
    /* @__PURE__ */ jsxs("linearGradient", { id: getId("mango", id), gradientTransform: "rotate(4.77)", children: [
      /* @__PURE__ */ jsx("stop", { offset: "0%", stopColor: "#FA9E00" }),
      /* @__PURE__ */ jsx("stop", { offset: "100%", stopColor: "#FF8E26" })
    ] })
  ] });
}
function getId(gradient, suffix) {
  return `${FLEX_GRADIENT_SVG_ID[gradient]}-${suffix}`;
}

export { FLEX_GRADIENT_SVG_ID, FlexLinearGradient, getId };
//# sourceMappingURL=LinearGradient.mjs.map
